import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    actionName: string;
    subtitle: string;
    search: string;
    outputLanguages: string;
    infoText: string;
    generate: string;
    cancel: string;
    dialogCloseLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Name of the translate video action. */
            actionName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyTranslateDialog.actionName?c=170ozhiprf4oi", defaultMessage: "Translate Video" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Subtitle of the translate video dialog. */
            subtitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyTranslateDialog.subtitle?c=tu4kq4x723uu", defaultMessage: "Translate video into other languages." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Search input placeholder */
            search: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyTranslateDialog.search?c=3urfhu5j4omas", defaultMessage: "Search" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Languages the user wants to translate the video into. */
            outputLanguages: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyTranslateDialog.outputLanguages?c=z9qz555ue2sj", defaultMessage: "Output Languages" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Restrictions on the translate video feature. */
            infoText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyTranslateDialog.infoText?c=2qgeqnstn1oth", defaultMessage: "This feature only supports H265/H264 video files up to 30 minutes long." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Submit button text. */
            generate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyTranslateDialog.generate?c=3ro1smuto4dg5", defaultMessage: "Generate Variations" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Cancel button text. */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyTranslateDialog.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** This text is used to close the dialog. */
            dialogCloseLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyTranslateDialog.dialogCloseLabel?c=2g2kiprif3vje", defaultMessage: "Close Dialog" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
